"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeMetadata = void 0;
/**
 * Remove metadata in contentful object recursively.
 * NOTE: Currently removes everything in `sys` objects except for `id`
 *
 * @param {object} data
 * @returns {object}
 */
const removeMetadata = (data) => {
    if (Array.isArray(data)) {
        for (const item of data) {
            (0, exports.removeMetadata)(item);
        }
    }
    else if (typeof data === 'object' && data !== null) {
        const { sys } = data;
        if (typeof sys === 'object' && (sys === null || sys === void 0 ? void 0 : sys.id)) {
            data.sys = {
                id: sys.id
            };
        }
        const entries = Object.keys(data);
        for (const entry of entries) {
            (0, exports.removeMetadata)(data[entry]);
        }
    }
    return data;
};
exports.removeMetadata = removeMetadata;
exports.default = exports.removeMetadata;
//# sourceMappingURL=removeMetadata.js.map